import Vue from 'vue'
import Vuex from 'vuex'
import common from './common'
import liveDetail from './modules/live-detail'

Vue.use(Vuex)

export default new Vuex.Store({
  ...common,
  modules: {
    liveDetail
  }
})
